import { render, staticRenderFns } from "./AttendEvent.vue?vue&type=template&id=37544b22&scoped=true&"
import script from "./AttendEvent.vue?vue&type=script&lang=js&"
export * from "./AttendEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37544b22",
  null
  
)

export default component.exports